import { keysToCamelCase } from "zod-to-camel-case";

import type {
  TeacherTips,
  TeacherTipsCamel,
} from "@/schema/public/components/teacherTips/teacherTips.schema";

export const teacherTipsFixture = ({
  overrides = {},
}: {
  overrides?: Partial<TeacherTips>;
} = {}): TeacherTips => ({
  teacher_tip: "Example teacher tip",
  ...overrides,
});

export const teacherTipsFixtureCamel = ({
  overrides = {},
}: {
  overrides?: Partial<TeacherTipsCamel>;
} = {}): TeacherTipsCamel =>
  keysToCamelCase(
    teacherTipsFixture({
      overrides: overrides as Partial<TeacherTips>,
    }),
  );
